var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { GenericInputElement } from "./genericinputfield";
import { bind } from "decko";
import { isNullOrUndefined } from "../better/utils";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const selectClass = css({
    position: "relative",
    select: {
        cursor: "pointer",
        appearance: "none",
        height: "38px",
        padding: "8px",
        paddingRight: "25px",
        lineHeight: "22px",
        "&:-moz-focusring": {
            color: "transparent",
            textShadow: "0 0 0 #000",
        },
    },
    "&:after": {
        content: '"▼"',
        display: "block",
        padding: "9px 10px",
        position: "absolute",
        pointerEvents: "none",
        right: 0,
        top: 0,
        fontSize: "10.8px",
    },
});
const disabledClass = css({
    "&:after": {
        color: getThemeColorVar("typo", "default"),
    },
});
const sizeClasses = {
    small: css({
        select: {
            height: "30px",
            padding: "4px 31px 4px 4px",
        },
        "&:after": {
            padding: "5px 10px",
        },
    }),
    large: css({}),
};
export class Select extends GenericInputElement {
    constructor(props) {
        super(props);
        this.enableLiveValidation = true;
        this.state = this.defaultState;
    }
    handleChange(event) {
        this.setState({ isPristine: false });
        const flatOptions = this.props.options.reduce((acc, option) => {
            if ("options" in option) {
                return [...acc, ...option.options];
            }
            else {
                return [...acc, option];
            }
        }, []);
        const maybeOption = flatOptions[event.target.selectedIndex];
        let selectedValue;
        if (maybeOption && "value" in maybeOption) {
            selectedValue = maybeOption.value;
        }
        else {
            selectedValue = undefined;
        }
        this.props.onValueChange &&
            this.props.onValueChange(selectedValue, !maybeOption.disabled);
    }
    renderInner() {
        const classes = [selectClass];
        this.props.disabled && classes.push(disabledClass);
        this.props.size && classes.push(sizeClasses[this.props.size]);
        function isOptionGroup(value) {
            return !isNullOrUndefined(value.options);
        }
        const options = this.props.options.map((option, idx) => {
            var _a, _b;
            if (isOptionGroup(option)) {
                return (React.createElement("optgroup", { key: `group--${option.label}`, label: option.label, disabled: option.disabled }, option.options.map((opt) => (React.createElement("option", { key: opt.value, value: opt.value }, opt.label)))));
            }
            else {
                return (React.createElement("option", { key: (_b = (_a = option.value) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : `option-${idx}`, value: option.value, disabled: option.disabled }, option.label));
            }
        });
        return (React.createElement("div", { className: cx(classes) },
            React.createElement("select", { id: this.props.id, ref: (el) => (this.inputElRef = el), disabled: this.props.disabled, value: this.props.value, defaultValue: this.props.defaultValue || undefined, name: this.props.name, required: this.props.required, onChange: this.handleChange, onFocus: this.props.onFocus, autoFocus: this.props.autoFocus, onKeyDown: this.props.onKeyDown, tabIndex: this.props.tabIndex }, options)));
    }
}
Select.defaultProps = {
    readOnly: false,
    useDefault: false,
    defaultValue: null,
    options: [],
};
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Select.prototype, "handleChange", null);
export default Select;
//# sourceMappingURL=select.js.map